import { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { http, formatApiError } from "@/lib/api";
import { useProfile } from "@/context/ProfileContext";
import { CourseWork } from "@/components/dashboard/CourseWork";
import { CatchUpCard } from "@/components/dashboard/CatchUpCard";
import { GradeTrends } from "@/components/dashboard/GradeTrends";

export default function CourseWorkPage() {
  const { studentId } = useParams();
  const { profile } = useProfile();
  const [f, setF] = useState({ subject: "", status: "" });
  const [d, setD] = useState(null);
  const [err, setErr] = useState(null);
  const [show, setShow] = useState(true);
  const load = useCallback(() => http.get(`/coursework/${studentId}`, { params: { subject: f.subject || undefined, status: f.status || undefined } }).then((r) => setD(r.data)).catch((e) => setErr(formatApiError(e))), [studentId, f]);
  useEffect(() => { load(); }, [load]);
  if (err) return <p className="max-w-5xl mx-auto px-6 py-16 text-[#C87D53]" data-testid="coursework-page-error">{err}</p>;
  return (
    <div className="max-w-5xl mx-auto px-6 lg:px-10 py-12 pb-24" data-testid="coursework-page">
      <span className="text-xs font-semibold uppercase tracking-[0.25em] text-[#C87D53]">Course work</span>
      <h1 className="font-display text-4xl sm:text-5xl text-[#2C4A3E] mt-2">All assignments & scores</h1>
      {profile.role === "parent" && <CatchUpCard studentId={studentId} onDone={load} />}
      <GradeTrends studentId={studentId} refresh={d ? JSON.stringify(d.items.map((i) => i.quiz_score)) : ""} />
      {d && <CourseWork d={d} f={f} setF={setF} showCounts={show} setShowCounts={setShow} onChange={load} />}
    </div>
  );
}
